import React, { Component } from "react";
import "./TotalCss.css";
import { Row, Col, Button, Form, FormGroup, Label, Input } from 'reactstrap';
import { SiteTitle } from "./SiteTitle";
import { FetchDataResearch } from "./FetchDataResearch";
import { SelectUrl } from "./BasicComponents/SelectUrl";
import { api_url } from "./globalFunction/global_string";
import { SelectUnit } from "./BasicComponents/SelectUnit";
import { SelectResearchUrl } from "./BasicComponents/SelectResearchUrl";
import { SelectNet } from "./BasicComponents/SelectNet";
import { SelectUnitproxyApply } from "./BasicComponents/SelectUnitproxyApply";

export class SiteResultResearch extends Component {
  static displayName = SiteResultResearch.name;

  constructor(props) {
    super(props);
    const date = new Date();
    const endDate = new Date(date);

    // 加 1 天
    endDate.setDate(endDate.getDate() + 1);

    // 將 Date 對象轉回到 YYYY-MM-DD 的字符串格式
    const endDay = endDate.toLocaleDateString('zh-TW', { timeZone: 'Asia/Taipei', year: 'numeric', month: '2-digit', day: '2-digit' }).replace(/\//g, '-');
    const startDate = new Date(new Date().setFullYear(new Date().getFullYear() - 1)).toISOString().substring(0, 10);

    this.state = {
      showModal: false, //初始化 modal 關閉
      isDataFetched: false, // 初始化尚未取得資料
      historyData: [], // 初始化歷史數據
      setHistoryData: this.setHistoryData, // 更新歷史數據的函數
      fetchedData: {
        current_user_type: localStorage.getItem('login_user_type'),
        local_net_id: localStorage.getItem('login_user_net_id'),
        local_unit_id: localStorage.getItem('login_user_unit_id'),
        url_addr: '',
        apiUrl: '',
        firstLocalUnitName: '',
        firstLocalUnitValue: '',
        selectedUnit: '',
        local_unit_name: '',
        selectedRisk: 'All',
        betaversion: '0',
        startDate: startDate, // 預設為 null
        endDate: endDay, // 預設為 null
      }, // 初始化資料容器
      formData: {
        selectedOption: 'Y',
        excel_unit_name: '',
        excel_unit_url: '',
      }
    }
  }

  componentDidMount() {
    this.loadData();
  }

  setHistoryData = (newHistoryData) => {
    this.setState({ historyData: newHistoryData });
  };

  loadData() {
    let apiUrl = api_url + "/api/JRCC/GetLocalUnitId";
    const formData = new FormData();
    formData.append("current_user_type", localStorage.getItem('login_user_type'));
    formData.append("local_net_id", localStorage.getItem('login_user_net_id'));
    formData.append("local_unit_id", localStorage.getItem('login_user_unit_id'));

    fetch(apiUrl, {
      method: "POST",
      headers: { "Authorization": localStorage.getItem('accessToken') },
      body: formData
    })
      .then(response => response.json())
      .then(data => {
        if (data.row && Array.isArray(data.row) && data.row.length > 0) {
          this.setState({
            firstLocalUnitName: data.row[0].local_unit_name,
            firstLocalUnitValue: data.row[0].local_unit_id
          });
        }
      })
      .catch(error => {
        console.error('Error:', error);
      });
  }



  toggleModal = () => {
    this.setState({
      showModal: !this.state.showModal
    })
  }


  //這邊是把資料傳到下一層
  handleSubmit = (event) => {
    event.preventDefault();
    // 將isDataFetched設置為false以觸發重新渲染
    this.setState({
      isDataFetched: false
    }, () => {
      let apiUrl = api_url + "/api/SCHE/GetScan";
      // 更新fetchedData並將isDataFetched設置為true
      this.setState((prevState) => ({
        isDataFetched: true,
        fetchedData: {
          ...prevState.fetchedData, // 保留已有的 fetchedData 中的其他屬性
          url_addr: this.state.formData.excel_unit_url, // 將 excel_unit_url 的值賦給 url_addr
          selectedUnit: this.state.selectedUnit,
          local_unit_name: this.state.local_unit_name,
          selectedUnitproxy: this.state.selectedUnitproxy,
          local_unit_proxy_name: this.state.local_unit_proxy_name,
          selectnet: this.state.selectnet,
          local_net_name: this.state.local_net_name,
          apiUrl: apiUrl,
        }
      }));
    });
  };
  // 處理單位選擇變更事件
  handleUnitSelectChange = (data) => {
    console.log(data);
    const { value, selectedName } = data;

    this.setState(prevState => ({
      selectedUnit: value,
      local_unit_name: selectedName,
    }), () => {
      //.log("Selected unit updated:", this.state.selectedUnit, this.state.local_unit_name);
    });
  };
  handleOptionChange = (event) => {
    const { name, value } = event.target;
    this.setState((prevState) => ({
      formData: {
        ...prevState.formData,
        [name]: value,
      }
    }),
    );
  };
  handleRiskChange = (event) => {
    const { value } = event.target;
    this.setState(prevState => ({
      fetchedData: {
        ...prevState.fetchedData,
        selectedRisk: value,
      },
    }));
  };


  // 處理網域選擇
  handleNetSelectChange = (data) => {
    const { value, selectedName } = data;
    this.setState((prevState) => ({
      selectnet: value,
      local_net_name: selectedName,
      selectedUnitproxy: '',  // 清空單位
      local_unit_proxy_name: '',  // 清空單位名稱
      formData: {
        selectedUnitproxy: '',  // 清空單位
        local_unit_proxy_name: '',  // 清空單位名稱
        ...prevState.formData,
        excel_unit_url: '',  // 清空網址
      }
    }), () => {
      // console.log("Selected net updated:", this.state.selectnet, this.state.local_net_name);
    });
  };

  SelectUnitproxyApply = (data) => {
    const { value, selectedName } = data;
    this.setState({ selectedUnitproxy: value, local_unit_proxy_name: selectedName }, () => {
      // console.log("Selected unit updated:", this.state.selectedUnitproxy, this.state.local_unit_proxy_name);
    });
  };


  //版本選擇的複選框
  handlecheckboxOptionChange = (event) => {
    const newFetchedData = {
      ...this.state.fetchedData,
      betaversion: event.target.value
    };

    // 然後使用 setState 更新狀態
    this.setState({ fetchedData: newFetchedData });
  };

  //日期更改
  handleOptionChange = (event) => {
    const { name, value } = event.target;
    if (name === "startDate" || name === "endDate") {
      this.setState((prevState) => ({
        fetchedData: {
          ...prevState.fetchedData,
          [name]: value,
        }
      }));
    } else {
      this.setState((prevState) => ({
        formData: {
          ...prevState.formData,
          [name]: value,
        }
      }));
    }
  };

  render() {
    const date = new Date();
    const today = date.toLocaleDateString('zh-TW', { timeZone: 'Asia/Taipei', year: 'numeric', month: '2-digit', day: '2-digit' }).replace(/\//g, '-');
    const endDate = new Date(today);

    // 加 1 天
    endDate.setDate(endDate.getDate() + 1);

    // 將 Date 對象轉回到 YYYY-MM-DD 的字符串格式
    const endDay = endDate.toLocaleDateString('zh-TW', { timeZone: 'Asia/Taipei', year: 'numeric', month: '2-digit', day: '2-digit' }).replace(/\//g, '-');

    const userType = localStorage.getItem('login_user_type');
    const net_name = localStorage.getItem('login_user_net_name');
    let FormDataUsertype;
    if (userType === 'S') {
      FormDataUsertype = (
        <Form>
          <FormGroup row inline>
            <Label for="local_net_id" sm={2}>區網名稱</Label>
            <Col sm={10}>
              <SelectNet
                parentName={'superS'}
                id={'excel_net_name'}
                name={'excel_net_name'}
                requiredAPI={'/api/JRCC/GetLocalNetId'}
                handleNetSelectChange={this.handleNetSelectChange}
              />
            </Col>
          </FormGroup>
          <FormGroup row inline>
            <Label for="excel_unit_proxy_name" sm={2}>單位名稱</Label>
            <Col sm={10}>
              <SelectUnitproxyApply
                parentName={'superS'}
                id={'excel_unit_proxy_name'}
                name={'excel_unit_proxy_name'}
                requiredAPI={'/api/Async/GetNetDownUnitlist'}
                SelectUnitproxyApply={this.SelectUnitproxyApply}
                selectnet={this.state.selectnet}
                local_net_name={this.state.local_net_name}
              />
            </Col>
          </FormGroup>
          <FormGroup row inline>
            <Label for="excel_unit_url" sm={2}>網站名稱</Label>
            <Col sm={10}>
              <SelectResearchUrl
                parentName={'superS'}
                id={'excel_unit_url'}
                name={'excel_unit_url'}
                requiredAPI={'/api/JRCC/GetLocalUrlId'}
                selectedUnit={this.state.selectedUnitproxy}
                local_unit_name={this.state.local_unit_proxy_name}
                onChange={this.handleOptionChange} />
            </Col>
          </FormGroup>
          <FormGroup row inline>
            <Label for="startDate" sm={2}>開始日期</Label>
            <Col sm={10}>
              <input
                type="date"
                id="startDate"
                name="startDate"
                value={this.state.fetchedData.startDate}
                max={today}
                onChange={this.handleOptionChange}
              />
            </Col>
          </FormGroup>
          <FormGroup row inline>
            <Label for="endDate" sm={2}>結束日期</Label>
            <Col sm={10}>
              <input
                type="date"
                id="endDate"
                name="endDate"
                value={this.state.fetchedData.endDate}
                min={this.state.fetchedData.startDate}
                max={endDay}
                onChange={this.handleOptionChange}
              />
            </Col>
          </FormGroup>
          <FormGroup row inline>
            <Label for="riskLevel" sm={2}>風險程度</Label>
            <Col sm={10}>
              <div className="d-flex justify-content-between" style={{ width: '100%' }}>
                <div className="mr-3">
                  <Input type="radio" name="riskLevel" value="All" checked={this.state.fetchedData.selectedRisk === 'All'} onChange={this.handleRiskChange} />
                  <Label>全部</Label>
                </div>
                <div className="mr-3">
                  <Input type="radio" name="riskLevel" value="Heavy" checked={this.state.fetchedData.selectedRisk === 'Heavy'} onChange={this.handleRiskChange} />
                  <Label>重風險</Label>
                </div>
                <div className="mr-3">
                  <Input type="radio" name="riskLevel" value="High" checked={this.state.fetchedData.selectedRisk === 'High'} onChange={this.handleRiskChange} />
                  <Label>高風險</Label>
                </div>
                <div className="mr-3">
                  <Input type="radio" name="riskLevel" value="Medium" checked={this.state.fetchedData.selectedRisk === 'Medium'} onChange={this.handleRiskChange} />
                  <Label>中風險</Label>
                </div>
                <div className="mr-3">
                  <Input type="radio" name="riskLevel" value="Low" checked={this.state.fetchedData.selectedRisk === 'Low'} onChange={this.handleRiskChange} />
                  <Label>低風險</Label>
                </div>
                <div className="mr-3">
                  <Input type="radio" name="riskLevel" value="Message" checked={this.state.fetchedData.selectedRisk === 'Message'} onChange={this.handleRiskChange} />
                  <Label>訊息風險</Label>
                </div>
              </div>
            </Col>
          </FormGroup>
          <FormGroup tag="fieldset">
            <Row>
              <Label sm={2}>版本</Label>
              <Col sm={10}>
                <div className="d-flex justify-content-between" style={{ width: '100%' }}>
                  <div className="mr-3">
                    <Input type="radio" name="betaversion" value="0" checked={this.state.fetchedData.betaversion === '0'} onChange={this.handlecheckboxOptionChange} />
                    <Label>全部</Label>
                  </div>
                  <div className="mr-3">
                    <Input type="radio" name="betaversion" value="1" checked={this.state.fetchedData.betaversion === '1'} onChange={this.handlecheckboxOptionChange} />
                    <Label>開發版</Label>
                  </div>
                  <div className="mr-3">
                    <Input type="radio" name="betaversion" value="2" checked={this.state.fetchedData.betaversion === '2'} onChange={this.handlecheckboxOptionChange} />
                    <Label>測試版</Label>
                  </div>
                  <div className="mr-3">
                    <Input type="radio" name="betaversion" value="3" checked={this.state.fetchedData.betaversion === '3'} onChange={this.handlecheckboxOptionChange} />
                    <Label>上線版</Label>
                  </div>
                </div>
              </Col>
            </Row>
          </FormGroup>
          <FormGroup row>
            <Button type="submit" className="btn btn-primary col-md-2 col-lg-1 mx-1 my-2" onClick={this.handleSubmit}>查詢</Button>
          </FormGroup>
        </Form>
      );
    } else if (userType === 'M') {
      FormDataUsertype = (
        <Form>
          <FormGroup row inline>
            <Label sm={2}>區網名稱</Label>
            <Col sm={10}>
              <span className="form-control-plaintext">{net_name}</span>
            </Col>
          </FormGroup>
          <FormGroup row inline>
            <Label for="excel_unit_name" sm={2}>單位名稱</Label>
            <Col sm={10}>
              <SelectUnitproxyApply
                parentName={'superM'}
                id={'excel_unit_proxy_name'}
                name={'excel_unit_proxy_name'}
                requiredAPI={'/api/Async/GetNetDownUnitlist'}
                SelectUnitproxyApply={this.SelectUnitproxyApply}
              />
            </Col>
          </FormGroup>
          <FormGroup row inline>
            <Label for="excel_unit_url" sm={2}>網站名稱</Label>
            <Col sm={10}>
              <SelectResearchUrl
                parentName={'superS'}
                id={'excel_unit_url'}
                name={'excel_unit_url'}
                requiredAPI={'/api/JRCC/GetLocalUrlId'}
                selectedUnit={this.state.selectedUnitproxy}
                local_unit_name={this.state.local_unit_proxy_name}
                onChange={this.handleOptionChange} />
            </Col>
          </FormGroup>
          <FormGroup row inline>
            <Label for="startDate" sm={2}>開始日期</Label>
            <Col sm={10}>
              <input
                type="date"
                id="startDate"
                name="startDate"
                value={this.state.fetchedData.startDate}
                max={today}
                onChange={this.handleOptionChange}
              />
            </Col>
          </FormGroup>
          <FormGroup row inline>
            <Label for="endDate" sm={2}>結束日期</Label>
            <Col sm={10}>
              <input
                type="date"
                id="endDate"
                name="endDate"
                value={this.state.fetchedData.endDate}
                min={this.state.fetchedData.startDate}
                max={endDay}
                onChange={this.handleOptionChange}
              />
            </Col>
          </FormGroup>
          <FormGroup row inline>
            <Label for="riskLevel" sm={2}>風險程度</Label>
            <Col sm={10}>
              <div className="d-flex justify-content-between" style={{ width: '100%' }}>
                <div className="mr-3">
                  <Input type="radio" name="riskLevel" value="All" checked={this.state.fetchedData.selectedRisk === 'All'} onChange={this.handleRiskChange} />
                  <Label>全部</Label>
                </div>
                <div className="mr-3">
                  <Input type="radio" name="riskLevel" value="Heavy" checked={this.state.fetchedData.selectedRisk === 'Heavy'} onChange={this.handleRiskChange} />
                  <Label>重風險</Label>
                </div>
                <div className="mr-3">
                  <Input type="radio" name="riskLevel" value="High" checked={this.state.fetchedData.selectedRisk === 'High'} onChange={this.handleRiskChange} />
                  <Label>高風險</Label>
                </div>
                <div className="mr-3">
                  <Input type="radio" name="riskLevel" value="Medium" checked={this.state.fetchedData.selectedRisk === 'Medium'} onChange={this.handleRiskChange} />
                  <Label>中風險</Label>
                </div>
                <div className="mr-3">
                  <Input type="radio" name="riskLevel" value="Low" checked={this.state.fetchedData.selectedRisk === 'Low'} onChange={this.handleRiskChange} />
                  <Label>低風險</Label>
                </div>
                <div className="mr-3">
                  <Input type="radio" name="riskLevel" value="Message" checked={this.state.fetchedData.selectedRisk === 'Message'} onChange={this.handleRiskChange} />
                  <Label>訊息風險</Label>
                </div>
              </div>
            </Col>
          </FormGroup>
          <FormGroup tag="fieldset">
            <Row>
              <Label sm={2}>版本</Label>
              <Col sm={10}>
                <div className="d-flex justify-content-between" style={{ width: '100%' }}>
                  <div className="mr-3">
                    <Input type="radio" name="betaversion" value="0" checked={this.state.fetchedData.betaversion === '0'} onChange={this.handlecheckboxOptionChange} />
                    <Label>全部</Label>
                  </div>
                  <div className="mr-3">
                    <Input type="radio" name="betaversion" value="1" checked={this.state.fetchedData.betaversion === '1'} onChange={this.handlecheckboxOptionChange} />
                    <Label>開發版</Label>
                  </div>
                  <div className="mr-3">
                    <Input type="radio" name="betaversion" value="2" checked={this.state.fetchedData.betaversion === '2'} onChange={this.handlecheckboxOptionChange} />
                    <Label>測試版</Label>
                  </div>
                  <div className="mr-3">
                    <Input type="radio" name="betaversion" value="3" checked={this.state.fetchedData.betaversion === '3'} onChange={this.handlecheckboxOptionChange} />
                    <Label>上線版</Label>
                  </div>
                </div>
              </Col>
            </Row>
          </FormGroup>
          <FormGroup row>
            <Button type="submit" className="btn btn-primary col-md-2 col-lg-1 mx-1 my-2" onClick={this.handleSubmit}>查詢</Button>
          </FormGroup>
        </Form>
      );
    } else {
      FormDataUsertype = (
        <Form>
          <FormGroup row inline>
            <Label for="excel_unit_name" sm={2}>單位名稱</Label>
            <Col sm={10}>
              {this.state.fetchedData.current_user_type === 'N' ? (
                <span className="form-control-plaintext">{this.state.firstLocalUnitName}</span>
              ) : (
                <SelectUnit
                  parentName={'Excel'}
                  id={'excel_unit_name'}
                  name={'excel_unit_name'}
                  requiredAPI={'/api/JRCC/GetLocalUnitId'}
                  onUnitSelectChange={this.handleUnitSelectChange}
                />
              )}
            </Col>
          </FormGroup>
          <FormGroup row inline>
            <Label for="excel_unit_url" sm={2}>網站名稱</Label>
            <Col sm={10}>
              {this.state.fetchedData.current_user_type === 'N' ? (
                <SelectResearchUrl
                  parentName={'url'}
                  id={'excel_unit_url'}
                  name={'excel_unit_url'}
                  requiredAPI={'/api/JRCC/GetLocalUrlId'}
                  selectedUnit={this.state.firstLocalUnitValue}
                  local_unit_name={this.state.firstLocalUnitName}
                  onChange={this.handleOptionChange} />
              ) : (
                <SelectResearchUrl
                  parentName={'url'}
                  id={'excel_unit_url'}
                  name={'excel_unit_url'}
                  requiredAPI={'/api/JRCC/GetLocalUrlId'}
                  selectedUnit={this.state.selectedUnit}
                  local_unit_name={this.state.local_unit_name}
                  onChange={this.handleOptionChange} />
              )}
            </Col>
          </FormGroup>
          <FormGroup row inline>
            <Label for="startDate" sm={2}>開始日期</Label>
            <Col sm={10}>
              <input
                type="date"
                id="startDate"
                name="startDate"
                value={this.state.fetchedData.startDate}
                max={today}
                onChange={this.handleOptionChange}
              />
            </Col>
          </FormGroup>
          <FormGroup row inline>
            <Label for="endDate" sm={2}>結束日期</Label>
            <Col sm={10}>
              <input
                type="date"
                id="endDate"
                name="endDate"
                value={this.state.fetchedData.endDate}
                min={this.state.fetchedData.startDate}
                max={endDay}
                onChange={this.handleOptionChange}
              />
            </Col>
          </FormGroup>
          <FormGroup row inline>
            <Label for="riskLevel" sm={2}>風險程度</Label>
            <Col sm={10}>
              <div className="d-flex justify-content-between" style={{ width: '100%' }}>
                <div className="mr-3">
                  <Input type="radio" name="riskLevel" value="All" checked={this.state.fetchedData.selectedRisk === 'All'} onChange={this.handleRiskChange} />
                  <Label>全部</Label>
                </div>
                <div className="mr-3">
                  <Input type="radio" name="riskLevel" value="Heavy" checked={this.state.fetchedData.selectedRisk === 'Heavy'} onChange={this.handleRiskChange} />
                  <Label>重風險</Label>
                </div>
                <div className="mr-3">
                  <Input type="radio" name="riskLevel" value="High" checked={this.state.fetchedData.selectedRisk === 'High'} onChange={this.handleRiskChange} />
                  <Label>高風險</Label>
                </div>
                <div className="mr-3">
                  <Input type="radio" name="riskLevel" value="Medium" checked={this.state.fetchedData.selectedRisk === 'Medium'} onChange={this.handleRiskChange} />
                  <Label>中風險</Label>
                </div>
                <div className="mr-3">
                  <Input type="radio" name="riskLevel" value="Low" checked={this.state.fetchedData.selectedRisk === 'Low'} onChange={this.handleRiskChange} />
                  <Label>低風險</Label>
                </div>
                <div className="mr-3">
                  <Input type="radio" name="riskLevel" value="Message" checked={this.state.fetchedData.selectedRisk === 'Message'} onChange={this.handleRiskChange} />
                  <Label>訊息風險</Label>
                </div>
              </div>
            </Col>
          </FormGroup>
          <FormGroup tag="fieldset">
            <Row>
              <Label sm={2}>版本</Label>
              <Col sm={10}>
                <div className="d-flex justify-content-between" style={{ width: '100%' }}>
                  <div className="mr-3">
                    <Input type="radio" name="betaversion" value="0" checked={this.state.fetchedData.betaversion === '0'} onChange={this.handlecheckboxOptionChange} />
                    <Label>全部</Label>
                  </div>
                  <div className="mr-3">
                    <Input type="radio" name="betaversion" value="1" checked={this.state.fetchedData.betaversion === '1'} onChange={this.handlecheckboxOptionChange} />
                    <Label>開發版</Label>
                  </div>
                  <div className="mr-3">
                    <Input type="radio" name="betaversion" value="2" checked={this.state.fetchedData.betaversion === '2'} onChange={this.handlecheckboxOptionChange} />
                    <Label>測試版</Label>
                  </div>
                  <div className="mr-3">
                    <Input type="radio" name="betaversion" value="3" checked={this.state.fetchedData.betaversion === '3'} onChange={this.handlecheckboxOptionChange} />
                    <Label>上線版</Label>
                  </div>
                </div>
              </Col>
            </Row>
          </FormGroup>
          <FormGroup row>
            <Button type="submit" className="btn btn-primary col-md-2 col-lg-1 mx-1 my-2" onClick={this.handleSubmit}>查詢</Button>
          </FormGroup>
        </Form>
      );
    }
    return (
      <div>
        <SiteTitle />
        <div className="mt-5">
          <h1 id="tableLabel" className='mb-3'>檢測網站結果查詢</h1>
          <div id="site_manage" className="row col-12 mb-5">
            <div className="row justify-content-center">
              <div className="row col-sm-12 col-md-10 col-lg-8 rounded-3 d-inline-flex justify-content-center align-content-center mt-4">
                {FormDataUsertype}
              </div>
            </div>
          </div>
          {this.state.isDataFetched && <FetchDataResearch fetchedData={this.state.fetchedData} />}
        </div>
      </div>
    );
  }
}